import {
	isStoreFollowUp,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

import { updateStoreAssistant } from './updateStoreAssistant';

export const updateStoreAssistantMessageId = ({
	chat,
	oldId,
	newId,
}: {
	chat: StoreChatItem[];
	oldId: string;
	newId: string;
}): StoreChatItem[] => {
	const updatedChat = updateStoreAssistant({
		chat,
		promptId: oldId,
		updateFunction: (storeAssistant) => ({
			...storeAssistant,
			content: {
				...storeAssistant.content,
				message: {
					...storeAssistant.content.message,
					message: {
						...storeAssistant.content.message.message,
						id: newId,
					},
				},
			},
		}),
		updateType: 'Update Store Assistant Message ID',
	});

	return updatedChat.map((message) =>
		isStoreFollowUp(message) && message.agentMessageId === oldId
			? { ...message, agentMessageId: newId }
			: message,
	);
};
